module.exports = __webpack_public_path__ + "img/sml_chat_main_icon.b316b91.png";